import { InfographicButton as View } from 'ui-components'
import { useMapNavStore } from '~map-preview/states/mapNav'

export const InfographicButton = () => {
  const { setSideBar, setOpenDrawer, setOpenInfoGraphic } = useMapNavStore()
  const handleOpenInfographic = () => {
    setOpenDrawer(true)
    setSideBar('infographic')
    setOpenInfoGraphic(true)
  }
  return <View onClick={handleOpenInfographic} />
}
